import { render, staticRenderFns } from "./survey.vue?vue&type=template&id=c8cda4ac&scoped=true&"
import script from "./survey.vue?vue&type=script&lang=js&"
export * from "./survey.vue?vue&type=script&lang=js&"
import style0 from "./survey.vue?vue&type=style&index=0&id=c8cda4ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8cda4ac",
  null
  
)

export default component.exports